<template>
    <div>
    <!-- Diagnosis Section -->
        <section class="diagnosis">
            <div class="container">
                <div class="section-title">
                    <div class="title-decoration"></div>
                    <h2>Intelligent Diagnosis</h2>
                    <p>Enter your basic information to instantly view recommended countries and cities </p>
                </div>

                <div class="diagnosis-container">
                    <form class="diagnosis-form" @submit.prevent="runDiagnosis">
                        <div class="form-group" :hidden="true">
                            <select id="region" v-model="diagnosisForm.region" @change="onRegionChange">
                                <option value="">Choose the region</option>
                                <option v-for="region in regions" :key="region" :value="region">{{ region.split('/')[0].trim() }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <select id="industry" v-model="diagnosisForm.industry">
                                <option value="">select industry</option>
                                <option v-for="industry in industries" :key="industry" :value="industry">{{ industry.split('/')[0].trim() }}</option>
                            </select>
                        </div>

                        <div>
                            <button type="submit"
                                style="width: 200px;height: 40px;background: #FF9E1B;border-radius: 8px 8px 8px 8px;border:1px solid #FF9E1B;">
                                DIAGNOSE NOW
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </section>

        <section v-if="showAnalysis" class="analysis-recommend">
            <div class="container">
                <h3>Analysis and Recommendations</h3>
                <div class="analysis-grid">
                    <div class="analysis-item" v-for="item in analysisResults" :key="item.id">
                        <div class="analysis-header">
                            <img src="../assets/icon_locate.png" alt="Location" />
                            <p>{{ item.title }}</p>
                        </div>
                        <div class="divider"></div>
                        <div class="analysis-content">
                            <p class="content-label">Industrial Parks:</p>
                            <div class="content-box">
                                <p v-if="!item.content.Industrial_Parks" class="empty-text">None</p>
                                <div v-else class="filled-box">
                                    <p>{{item.content.Industrial_Parks}}</p>
                                </div>
                            </div>
                            <p class="content-label">Government / Investment Promotion Agencies:</p>
                            <div class="content-box">
                                <p v-if="!item.content.Government_Investment_Promotion_Agencies" class="empty-text">
                                    None</p>
                                <div v-else class="filled-box">
                                    <p>{{item.content.Government_Investment_Promotion_Agencies}}</p>
                                </div>
                            </div>
                            <p class="content-label">Policy Highlights:</p>
                            <div class="content-box">
                                <p v-if="!item.content.Policy_Highlights" class="empty-text">None</p>
                                <div v-else class="filled-box">
                                    <p>{{item.content.Policy_Highlights}}</p>
                                </div>
                            </div>
                            <p class="content-label">Partnership Resources</p>
                            <div class="contact-link">
                                <a href="#" @click.prevent="$scrollToRefById('global-contact-us', {}, true)">Contact Us</a>
                            </div>
                        </div>
                        <div class="divider"></div>
                        <div class="report-buttons">
                            <button class="btn-primary" style="background-color: #265FFF;color: white;" @click="showCityInfo(item.citySign)">
                                View City Info
                            </button>
                            <!--
                            <button class="btn-primary" style="background-color: #265FFF;color: white;"
                                @click="showCityReport">View City Report</button>
                            <button class="btn-outline" @click="showCountryReport">View Country Report</button>
                            -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <StaticData  ref="staticData" :showAnalysis="showAnalysis"/>
    </div>
</template>

<script>

import StaticData from '../components/StaticData.vue';

export default {
    name: 'Predict',
    components: {
        StaticData
    },
    data() {
        return {
            // 卡片配置数组：后续修改/新增/删除卡片，仅需操作此数组
            relatedCards: [
                {
                type: 'blue', // 卡片颜色类（对应原 related-section__card--blue）
                title: 'Market Entry into China', // 卡片标题
                items: [ // 卡片列表项
                    'City/Province Investment Promotion Materials (PDF + Interpretation)',
                    'Supply Chain Procurement, Channel & Agent Matching',
                    'Access to Industry Exhibitions & Events (Canton Fair, CHTF, etc)',
                    'Brand Localization & E-commerce Channel Development',
                    'Specialized Training to Enhance Practical Capabilities for Entering the Chinese Market'
                ]
                },
                {
                type: 'dark-blue', // 卡片颜色类（对应原 related-section__card--dark-blue）
                title: 'Market Entry Support for Southeast Asia',
                items: [
                    'Investment Policy Interpretation (Vietnam, Indonesia, Thailand, Singapore)',
                    'Industrial Park & Supply Chain Recommendations',
                    'Company Registration, Tax, and Employment Compliance',
                    'Customized Inspection Itineraries & Accompanied Liaison',
                    'Specialized Training to Enhance Capabilities for Entering the Southeast Asian Market'
                ]
                },
                {
                type: 'blue',
                title: 'Partnership Facilitation & Advisory',
                items: [
                    'Partner/Client Lead List (Unlock via Payment)',
                    'Online Advisory Session Booking (15-30 min)',
                    'Project-based Hand-holding (Planning + Execution + Review)',
                    'Compliance/Legal/Tax/Data Privacy Advisory',
                    'Specialized Training to Enhance Market Competitiveness'
                ]
                },
                {
                type: 'dark-blue',
                title: 'Specialized Training',
                items: [
                    'Understanding the Chinese Approach to Strategic Thinking',
                    'Learning Chinese Organizational Culture',
                    'Understanding the Market & Customer Ecosystem',
                    'Comprehending the Striver Culture & HR Mechanisms',
                    'Mastering the Chinese Efficient Operation System'
                ]
                }
            ],
            // 步骤配置数组：后续修改/新增步骤，仅需修改此数组
            processSteps: [
                {
                    icon: 'icon_process1.png', // 图片文件名（放在 assets 目录下）
                    title: 'Submit Requests',
                    desc: 'Fill out your industry, target country, and specific resource needs online, and our professional consultants will respond promptly'
                },
                {
                    icon: 'icon_process2.png',
                    title: 'Precise Matching',
                    desc: 'We screen and connect you with the most suitable resource providers in your target city based on your requirements, ensuring high-quality matches'
                },
                {
                    icon: 'icon_process3.png',
                    title: 'Online Consultation',
                    desc: 'Arrange one-on-one or multi-party online meetings with resource providers for efficient communication and preliminary verification of cooperation intent'
                },
                {
                    icon: 'icon_process4.png',
                    title: 'Satisfactory follow-up',
                    desc: 'For further collaboration, we assist in arranging on-site visits, translation support, itinerary coordination, and other follow-up services'
                }
            ],
            ResourceMatchingData: [
                {
                    serviceType: "Industrial Park Matchmaking",
                    description: "Connect with industrial parks in target countries to obtain firsthand information on sites, policies, tax incentives, and other benefits",
                    scenarios: "Establish factories, set up locations, establish regional headquarters"
                },
                {
                    serviceType: "Upstream and Downstream Industry Chain Integration",
                    description: "Matching raw material suppliers, manufacturers, distributors, technical partners, etc",
                    scenarios: "Cost reduction and efficiency improvement, supply chain optimization, technical"
                },
                {
                    serviceType: "Sales Channel Expansion",
                    description: "Connect with local distributors, agents, B2B/B2C clients, and e-commerce platforms",
                    scenarios: "Rapidly expand into overseas markets"
                },
                {
                    serviceType: "Government Relations /Investment Promotion",
                    description: "Collaborate with government investment departments, investment promotion agencies, and special economic zones to secure policy",
                    scenarios: "Policy Support, Subsidies, Project Applications"
                },
                {
                    serviceType: "Supplier/Purchasing Liaison",
                    description: "Assist buyers in finding suitable overseas suppliers, or help suppliers connect with buyers",
                    scenarios: "Procurement and Foreign Trade Cooperation"
                },
                {
                    serviceType: "Customized Resource Matching",
                    description: "Tailored matching based on specific user requirements (such as exhibition partnerships, association resources, industry connections, etc)",
                    scenarios: "Personalized needs"
                }
            ],
            services: [{
                    id: 'market-diagnosis',
                    title: 'Market Diagnosis',
                    description: 'Input your industry, product, and objectives to get recommendations for the most suitable countries and cities',
                    icon: 'fas fa-search',
                    features: [
                        'Get recommended countries & cities',
                        'Receive rationale & risk assessment',
                        'Customized market insights'
                    ]
                },
                {
                    id: 'market-entry',
                    title: 'Market Entry & Inspection',
                    description: 'Comprehensive support for entering new markets with policy interpretation and compliance registration',
                    icon: 'fas fa-plane',
                    features: [
                        'Policy interpretation',
                        'Compliance registration',
                        'Industrial park recommendations',
                        'Itinerary arrangement'
                    ]
                },
                {
                    id: 'partnership',
                    title: 'Partnership Facilitation',
                    description: 'Connect with reliable partners through our extensive enterprise resource pool',
                    icon: 'fas fa-handshake',
                    features: [
                        'Supply chain procurement',
                        'Channel/agent partnerships',
                        'ESB cooperation',
                        'Access to enterprise resource pool'
                    ]
                }
            ],
            diagnosisForm: {
                industry: '',
                region: ''
            },
            showAnalysis: false,
            regions: [],
            industries: [],
            predictionData: [],

            // 分析结果数据
            analysisResults: [],

            // 相关服务
            relatedServices: [{
                    id: 1,
                    title: 'Market Entry into China',
                    features: [
                        'City/Province Investment Promotion Materials (PDF + Interpretation)',
                        'Supply Chain Procurement, Channel & Agent Matching',
                        'Access to Industry Exhibitions & Events (Canton Fair, CHTF, etc)',
                        'Brand Localization & E-commerce Channel Development',
                        'Specialized Training to Enhance Practical Capabilities for Entering the Chinese Market'
                    ]
                },
                {
                    id: 2,
                    title: 'Market Entry Support for Southeast Asia',
                    features: [
                        'Investment Policy Interpretation (Vietnam, Indonesia, Thailand, Singapore)',
                        'Industrial Park & Supply Chain Recommendations',
                        'Company Registration, Tax, and Employment Compliance',
                        'Customized Inspection Itineraries & Accompanied Liaison',
                        'Specialized Training to Enhance Capabilities for Entering the  Southeast Asian Market'
                    ]
                },
                {
                    id: 3,
                    title: 'Partnership Facilitation & Advisory',
                    features: [
                        'Partner/Client Lead List (Unlock via Payment)',
                        'Online Advisory Session Booking (15-30 min)',
                        'Project-based Hand-holding (Planning + Execution + Review)',
                        'Compliance/Legal/Tax/Data Privacy Advisory',
                        'Specialized Training to Enhance Market Competitiveness'
                    ]
                },
                {
                    id: 4,
                    title: 'Specialized Training',
                    features: [
                        'Understanding the Chinese Approach to Strategic Thinking',
                        'Learning Chinese Organizational Culture',
                        'Understanding the Market & Customer Ecosystem',
                        'Comprehending the Striver Culture & HR Mechanisms',
                        'Mastering the Chinese Efficient Operation System'
                    ]
                }
            ],

            // 特色文档
            featuredDocuments: [{
                    id: 1,
                    title: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                    image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                    summary: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                    date: 'Last Updated: August 20, 2025',
                    url: '/documents/sea-investment-guide.pdf'
                },
                {
                        id: 2,
                        title: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                        image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                        summary: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                        date: 'Last Updated: August 20, 2025',
                        url: '/documents/sea-investment-guide.pdf'
                    },
                    {
                            id: 3,
                            title: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                            image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                            summary: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                            date: 'Last Updated: August 20, 2025',
                            url: '/documents/sea-investment-guide.pdf'
                        },
                        {
                                id: 4,
                                title: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                                image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                                summary: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                                date: 'Last Updated: August 20, 2025',
                                url: '/documents/sea-investment-guide.pdf'
                            }
            ],

            // 成功案例
            successStories: [{
                    id: 1,
                    title: 'EU → SHENZHEN',
                    description: 'A European new energy company established its Asia-Pacific headquarters in Shenzhen, becoming operational within 6 months and achieving local supply chain integration within 12 months',
                    image: 'https://images.unsplash.com/photo-1531299204812-e6d44d9a185c?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                },
                {
                    id: 2,
                    title: 'US → VIETNAM + CHINA',
                    description: 'A US components manufacturer: Set up a factory in Vietnam, sourced key molds from China, achieving a 12% cost reduction',
                    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                },
                {
                    id: 3,
                    title: 'JAPAN → SHANGHAI',
                    description: 'A Japanese consumer electronics brand entered tier-1 city distribution channels, implementing an integrated online and offline sales model',
                    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                }
            ],

            // 报告模态框
            showReportModal: false,
            currentReport: {}
        }
    },
    async mounted() {
        await this.fetchPredictionData();

        // 恢复保存的状态
        this.restoreState();
    },
    methods: {
        scrollToContact() {
            // this.$emit('handlerScrollToContactsUs', 'contact');
            // this.$scrollToRef('contact', { behavior: 'auto', block: 'center' });

        },

        async fetchPredictionData() {
            try {
                const response = await fetch('/res/config/os/prediction.json');
                this.predictionData = await response.json();
                this.extractRegionsAndIndustries();
            } catch (error) {
                console.error('Failed to fetch prediction data:', error);
            }
        },

        extractRegionsAndIndustries() {
            // 提取所有唯一的地区
            const regionSet = new Set();
            const industrySet = new Set();
            
            this.predictionData.forEach(item => {
                if (item.region) {
                    regionSet.add(item.region);
                }
                
                if (item.industries && Array.isArray(item.industries)) {
                    item.industries.forEach(industry => {
                        if (industry.industry) {
                            industrySet.add(industry.industry);
                        }
                    });
                }
            });
            
            this.regions = Array.from(regionSet);
            this.industries = Array.from(industrySet);
        },

        runDiagnosis() {
            if (!this.diagnosisForm.industry) {
            // if (!this.diagnosisForm.region || !this.diagnosisForm.industry) {
                // alert('Please select both region and industry');
                this.$toast.show({
                    // title: 'Prompt message',
                    // message: 'Please select both region and industry',
                    message: 'Please select industry',
                    // type: 'warning',
                    duration: 0
                });
                return;
            }

            // 根据选择的地区和行业过滤数据
            this.analysisResults = [];
            let idCounter = 1;

            this.predictionData.forEach(regionData => {
                // if (regionData.region === this.diagnosisForm.region) { // 去除掉区域的选择。只选择行业
                    regionData.industries.forEach(industry => {
                        if (industry.industry === this.diagnosisForm.industry) {
                            // 处理城市数据
                            if (industry.cities && industry.cities.length > 0) {
                                industry.cities.forEach(city => {
                                    this.analysisResults.push({
                                        id: idCounter++,
                                        title: city.country.split('/')[0].trim() + ", " + city.name.split('/')[0].trim(),
                                        citySign: city.sign,
                                        content: {
                                            Industrial_Parks: city.industrial_park.split('/')[0].trim() || '',
                                            Government_Investment_Promotion_Agencies: city.government_agency.split('/')[0].trim() || '',
                                            Policy_Highlights: city.policy_highlights.split('/')[0].trim() || ''
                                        }
                                    });
                                });
                            } else {
                                // 数据结构做了变化，不可能没有城市数据了，所以注释掉

                                // // 如果没有城市数据，只显示国家
                                // this.analysisResults.push({
                                //     id: idCounter++,
                                //     title: industry.country,
                                //     content: {
                                //         Industrial_Parks: industry.industrial_park || '',
                                //         Government_Investment_Promotion_Agencies: industry.government_agency || '',
                                //         Policy_Highlights: industry.policy_highlights || ''
                                //     }
                                // });
                            }
                        }
                    });
                // }
            });

            // 如果没有找到结果，提示即将呈现
            if (this.analysisResults.length === 0) {
                alert('Coming soon...');
                return;
            }

            this.showAnalysis = true;

            // 滚动到分析部分
            this.$nextTick(() => {
                const analysisSection = document.querySelector('.analysis-recommend');
                if (analysisSection) {
                    analysisSection.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            });
        },

        resetDiagnosis() {
            this.diagnosisForm = {
                industry: '',
                region: ''
            }
            this.showAnalysis = false
        },

        showCityInfo(sign) {
            // 跳转前缓存数据
            // 缓存下拉框选择数据
            const state = {
                relatedCards: this.relatedCards,
                processSteps: this.processSteps,
                ResourceMatchingData: this.ResourceMatchingData,
                services: this.services,
                diagnosisForm: this.diagnosisForm,
                showAnalysis: this.showAnalysis,
                regions: this.regions,
                industries: this.industries,
                predictionData: this.predictionData,
                analysisResults: this.analysisResults,
                relatedServices: this.relatedServices,
                featuredDocuments: this.featuredDocuments,
                successStories: this.successStories,
                showReportModal: this.showReportModal,
                currentReport: this.currentReport
            };
            sessionStorage.setItem('diagnosisState', JSON.stringify(state));
            // 跳转到城市信息页面
            this.$router.push('/city-info/' + sign);
        },

        showCountryReport() {
            this.currentReport = {
                title: 'Country Analysis Report',
                content: 'Comprehensive country-level analysis including market size, competition, regulatory environment...'
            }
            this.showReportModal = true
        },

        onRegionChange() {
            // 构建行业数据对象
            const industrySet = new Set();

            // region下拉框选择调整后，动态调整后面的行业内容信息。
            this.predictionData.forEach(item => {
                if (this.diagnosisForm.region === item.region) {
                    // 两个值相等时执行这里的代码
                    item.industries.forEach(industry => {
                        if (industry.industry) {
                            industrySet.add(industry.industry);
                        }
                    });
                }
            });
            
            this.industries = Array.from(industrySet);
            this.diagnosisForm.industry = ''; // ✅ 重置为默认项

        },
        // 从sessionStorage恢复状态
        restoreState() {
            const diagnosisState = sessionStorage.getItem('diagnosisState');
            console.log('Restoring diagnosisForm from sessionStorage:', diagnosisState);
            if (diagnosisState) {
                const state = JSON.parse(diagnosisState);
                Object.assign(this, state);
                this.runDiagnosis();
                // 恢复完，清理掉缓存。
                console.log('Clearing diagnosisState from sessionStorage');
                sessionStorage.removeItem('diagnosisState');
            }
        }
    }
}
</script>

<style scoped>
/* 基础样式 */
.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
}

/* Hero Section */
.hero {
    background: url('../assets/home_banner.jpg');
    background-size: cover;
    background-position: center;
    color: white;
    padding: 100px 0;
    text-align: center;
}

.hero h1 {
    font-size: 36px;
    margin-bottom: 20px;
    line-height: 1.2;
}

.hero p {
    font-size: 16px;
    max-width: 700px;
    margin: 0 auto 27px;
    line-height: 1.5;
}

/* Stats Section */
.stats {
    padding: 60px 0;
    background-color: #2444CB;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
}

/* Services Section */
/* Services Section - 修复响应式布局 */
.services {
    padding: 60px 0;
    background-color: white;
}

.services-wrapper {
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    gap: 80px;
    align-items: center;
}

.services-content {
    display: flex;
    flex-direction: column;
}

.services-list {
    display: flex;
    flex-direction: column;
    gap: 25px;
    margin-top: 30px;
}

.service-item {
    display: flex;
    align-items: flex-start;
    gap: 20px;
}

.service-icon {
    width: 42px;
    height: 42px;
    /* border-radius: 100px; */
    /* border: 2px solid #DDDDDD; */
    display: flex;
    justify-content: center;
    align-items: center;
    /* flex-shrink: 0; */
}

.service-icon img {
    width: 25px;
    height: 25px;
}

.service-text {
    flex: 1;
}

.service-title {
    font-size: 26px;
    color: #222222;
    margin-bottom: 8px;
    font-weight: 600;
}

.service-desc {
    font-size: 16px;
    color: #222222;
    line-height: 1.5;
}

.details-button {
    width: 200px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #265FFF;
    border-radius: 8px;
    margin-top: 40px;
}

.details-link {
    font-size: 14px;
    color: white;
    text-decoration: none;
    font-weight: 500;
}

.services-image {
    width: 100%;
    height: auto;
    border-radius: 8px;
    overflow: hidden;
    /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); */
    padding-top: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.services-image img {
    width: 100%;
    height: auto;
    object-fit: cover;
}

/* Diagnosis Section */
.diagnosis {
    padding: 100px 0;
    background-color: #2444CB;
}

.diagnosis .section-title h2 {
    font-size: 44px;
    color: white;
}

.diagnosis .section-title p {
    font-size: 16px;
    color: white;
}

.title-decoration {
    height: 12px;
    width: 60px;
    background-color: #FF9E1B;
    margin-bottom: 16px;
}

.diagnosis-container {
    margin: 0 auto;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.diagnosis-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

/* 下拉框样式调整 */
.form-group {
    position: relative;
}

.form-group select {
    width: 100%;
    font-size: 16px;
    padding: 12px 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
    /* 移除默认箭头并添加自定义样式 */
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: calc(100% - 12px) center;
    /* 向左移动20px */
    background-size: 16px;
    padding-right: 40px;
    /* 增加右侧内边距为箭头留空间 */
}

/* 单独设置联系表单的placeholder颜色 */
.contact-form input::placeholder,
.contact-form textarea::placeholder,
.contact-form select:invalid {
    color: #999;
}

.contact-form select option[value=""] {
    color: #999;
}

.form-buttons {
    grid-column: 1 / -1;
    display: flex;
    gap: 15px;
    margin-top: 20px;
}

.btn-primary {
    background-color: #FF9E1B;
    color: black;
    border: none;
    padding: 12px 24px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    flex: 1;
}

.btn-secondary {
    background-color: transparent;
    color: white;
    border: 1px solid white;
    padding: 12px 24px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    flex: 1;
}

/* Analysis Section */
.analysis-recommend {
    padding: 60px 0;
    background-color: white;
}

.analysis-recommend h3 {
    font-size: 32px;
    color: #222222;
    margin-bottom: 30px;
}

.analysis-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 30px;
    margin-top: 44px;
}

.analysis-item {
    border: 1px solid #2444CB;
    border-radius: 8px;
    padding: 10px 0px;
    background-color: white;
    display: flex;
    flex-direction: column;
}

.analysis-header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    /* height: 40px; */
    padding: 15px 20px;
}

.analysis-header img {
    height: 23px;
    width: 23px;
}

.analysis-header p {
    margin-left: 10px;
    font-family: Arial, Arial;
    font-weight: normal;
    font-size: 18px;
    color: #222222;
    line-height: 24px;
    font-style: normal;
    text-transform: none;
}

.divider {
    height: 1px;
    background-color: #2444CB;
    width: 100%;
    margin: 0 0;
}

.analysis-content {
    display: flex;
    flex-direction: column;
    padding: 25px;
    /* 增加内边距，使文字与边框距离增加 */
    font-size: 16px;
    flex: 1;
}

.content-label {
    color: #303030;
    margin-bottom: 12px;
    /* 增加标签与内容框之间的距离 */
}

.content-box {
    /* height: 50px; */
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    /* 增加内容框之间的间距 */
}

.empty-text {
    color: #999999;
}

.filled-box {
    border: 2px solid #2444CB;
    border-radius: 6px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 14px;
    padding: 10px 20px;

    height: auto; /* 不再填满父节点，让 padding 生效并扩高 */
    box-sizing: border-box;
    /* 为填充框内的文字增加内边距 */
}

.filled-box p {
    color: #2444CB;
    margin: 0;
}

.contact-link {
    display: flex;
    align-items: left;
    font-size: 14px;
    margin-top: 15px;
    /* 增加联系链接的顶部间距 */
}

.contact-link a {
    color: #265FFF;
    text-decoration: none;
}

.report-buttons {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 15px;
    margin-top: 10px;
    padding: 10px 20px;
}

.btn-outline {
    background-color: white;
    border: 1px solid #265FFF;
    color: #265FFF;
    padding: 12px 24px;
    border-radius: 4px;
    font-family: PingFang-SC, PingFang-SC;
    font-weight: 800;
    font-size: 14px;
    font-style: normal;
    height: 40px;
    cursor: pointer;
    transition: all 0.3s ease;
}

/* Related Services */
.related-services {
    padding: 60px 0;
    background-color: #2444CB;
    width: 100%;
}

.related-services .section-title h3 {
    font-size: 32px;
    color: white;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
}

.services-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
    gap: 30px;
    width: 100%;
}

.service-card {
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.card-header {
    background-color: #265FFF;
    color: white;
    padding-left: 31px;
}

.card-header h3 {
    margin: 0;
    font-size: 24px;
    font-family: Arial, Arial;
    font-weight: normal;
    height: 60px;
    display: flex;
    align-items: center;
}

.card-content {
    padding: 20px 25px 0 31px;
}

.card-content ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.card-content li {
    margin-bottom: 12px;
    padding-left: 20px;
    position: relative;
    font-size: 16px;
    line-height: 1.4;
}

.card-content li:before {
    content: "•";
    color: #265FFF;
    font-weight: bold;
    position: absolute;
    left: 0;
}

/* Featured Documents */
.featured-documents {
    padding: 60px 0;
    background-color: white;
}

.documents-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 30px;
}

.document-card {
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.document-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.document-image {
    height: 200px;
    overflow: hidden;
}

.document-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.document-summary {
    padding: 20px;
}

.document-summary p {
    margin-bottom: 10px;
    line-height: 1.5;
    font-size: 16px;
}

.document-date {
    color: #222222;
    font-size: 12px;
}

/* Success Stories */
.success-stories {
    padding: 60px 0;
    background-color: #2444CB;
}

.success-stories .section-title h2 {
    color: white;
    font-size: 32px;
}

.stories-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 30px;
}

.story-card {
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.story-content {
    display: flex;
    flex-direction: column;
    height: 220px;
    background: url('../assets/light_bg.png');
    background-size: cover;
    background-position: center;
    padding: 25px;
}

.story-content h3 {
    padding: 0;
    font-size: 20px;
    color: #222222;
    height: 60px;
    margin: 0;
    display: flex;
    align-items: center;
}

.story-description {
    height: 160px;
}

.story-description p {
    font-size: 18px;
    color: #222222;
    line-height: 1.4;
    margin: 0;
}

/* Contact Section */
.contact {
    padding: 60px 0;
    background-color: #022A4E;
}

.contact-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;
}

.footer-links {
    display: flex;
    gap: 35px;
    margin-top: auto; /* 这将把链接推到容器底部 */
    padding-top: 30px;
}

.footer-link {
    color: #b3cde0;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.3s ease;
}

.footer-link:hover {
    color: white;
}

/* 确保contact-info使用flex布局以支持底部对齐 */
.contact-info {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.contact-info .section-title h2 {
    font-size: 44px;
    color: white;
}

.contact-info .section-title p {
    color: white;
    font-size: 16px;
    line-height: 1.5;
}

.contact-details {
    margin-top: 30px;
    color: white;
}

.contact-details p {
    margin-bottom: 10px;
}

.social-links {
    margin-top: 30px;
}

.social-icons {
    display: flex;
    gap: 20px;
}

.social-icons a img {
    height: 31px;
    width: 31px;
}

.contact-form {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.contact-form h3 {
    color: #1a3a5f;
    margin-bottom: 20px;
    font-size: 24px;
}

.contact-form .form-group {
    margin-bottom: 20px;
    position: relative;
}

.contact-form input,
.contact-form select,
.contact-form textarea {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
    box-sizing: border-box;
}

/* 为联系表单的下拉框也应用相同的样式 */
.contact-form select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: calc(100% - 12px) center;
    background-size: 16px;
    padding-right: 40px;
}

.contact-form .btn-primary {
    background-color: #265FFF;
    width: 100%;
    color: white;
}

/* Report Modal */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.report-modal {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    max-width: 600px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
}

.report-content {
    margin: 20px 0;
    line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 1200px) {
    .container {
        padding: 0 40px;
    }

    .stats-grid {
        grid-template-columns: repeat(2, 1fr);
        /* 中等屏幕显示2列 */
    }

    .services-wrapper {
        gap: 60px;
    }

    .service-title {
        font-size: 24px;
    }
}

@media (max-width: 992px) {
    .contact-container {
        grid-template-columns: 1fr;
        gap: 30px;
    }

    .diagnosis-form {
        grid-template-columns: 1fr;
    }

    .services-wrapper {
        grid-template-columns: 1fr;
        gap: 50px;
    }

    .services-image {
        order: -1;
        /* 图片在上方 */
        max-width: 500px;
        margin: 0 auto;
    }

    .services-content {
        text-align: center;
    }

    .service-item {
        justify-content: center;
        text-align: center;
    }

    .details-button {
        margin: 40px auto 0;
    }
}

@media (max-width: 768px) {
    .container {
        padding: 0 20px;
    }

    .hero {
        padding: 40px 0;
    }

    .hero h1 {
        font-size: 28px;
    }

    .hero p {
        font-size: 14px;
    }

    .stats,
    .diagnosis,
    .analysis-recommend,
    .related-services,
    .services-packages,
    .services-process,
    .featured-documents,
    .success-stories,
    .contact {
        padding: 40px 0;
    }

    .stats-grid {
        grid-template-columns: 1fr;
        /* 小屏幕显示1列 */
        gap: 20px;
    }

    .section-title h2 {
        font-size: 24px;
    }

    .diagnosis .section-title h2 {
        font-size: 32px;
    }

    .contact-info .section-title h2 {
        font-size: 32px;
    }

    .services {
        padding: 40px 0;
    }

    .services-wrapper {
        gap: 40px;
    }

    .services-list {
        gap: 20px;
        margin-top: 25px;
    }

    .service-item {
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 15px;
    }

    .service-title {
        font-size: 22px;
    }

    .service-desc {
        font-size: 15px;
    }

    .services-image {
        max-width: 100%;
        height: 370px;
    }

    .analysis-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .documents-grid {
        grid-template-columns: 1fr;
    }

    .stories-grid {
        grid-template-columns: 1fr;
    }

    .form-buttons {
        flex-direction: column;
    }

    .report-buttons {
        padding: 0 15px;
    }

    .contact-form {
        padding: 20px;
    }
}

@media (max-width: 576px) {
    .services-wrapper {
        gap: 30px;
    }

    .service-title {
        font-size: 20px;
    }

    .service-desc {
        font-size: 14px;
    }

    .service-icon {
        width: 38px;
        height: 38px;
    }

    .service-icon img {
        width: 18px;
        height: 18px;
    }

    .details-button {
        width: 100%;
        max-width: 200px;
    }

    .services-image {
        height: 320px;
    }
}

@media (max-width: 480px) {
    .hero h1 {
        font-size: 24px;
    }

    .service-title {
        font-size: 18px;
    }

    .service-desc {
        font-size: 14px;
    }

    .services-list {
        gap: 25px;
    }

    .service-item {
        gap: 12px;
    }

    .diagnosis .section-title h2 {
        font-size: 28px;
    }

    .contact-info .section-title h2 {
        font-size: 28px;
    }

    .social-icons {
        justify-content: center;
    }

    .details-button {
        width: 100%;
        max-width: 200px;
        margin-left: auto;
        margin-right: auto;
    }
}

/** Resource Matching Services Section  */
/* 父容器：居中 + 自适应内边距 */
.services-grid {
  width: 100%;
  padding: 20px 15px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}

/* 响应式表格容器：兜底横向滚动（极端情况） */
.responsive-table {
  width: 100%;
  max-width: 1200px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; /* 移动端滚动流畅 */
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* 表头行（第1个Div） */
.table-header {
  display: flex;
  background-color: #1F39A7; 
  color: white;
  font-weight: 600;
  text-align: center; /* 表头文字左对齐 */
}

/* 表头单元格（子元素）：核心居中配置 */
.table-header .table-cell {
  display: flex; /* 启用 flex 实现自身内容居中 */
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  text-align: center; /* 兜底：应对单元格内有行内元素的情况 */
}

/* 表体（第2个Div） */
.table-body {
  display: flex;
  flex-direction: column;
}

/* 数据行（每个行是Div） */
.table-row {
  display: flex;
  width: 100%;
  background-color: #fff; /* 奇数行背景色 */
}

/* 偶数行背景色（初始生效） */
.table-row.even-row {
  background-color: #f8f9fd;
}

/* 单元格基础样式：左对齐+左右间距（大屏40px/移动端10px）+ 分行 */
.table-cell {
  padding: 16px 40px; /* 大屏左右40px间距（核心） */
  box-sizing: border-box;
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  font-size: 14px;
  line-height: 1.8; /* 优化行高，分行更美观 */
  text-align: left; /* 文字左对齐 */
  display: flex;
  align-items: flex-start; /* 垂直顶部对齐 */
  flex-wrap: wrap; /* 自动换行 */
}

/* 去掉最后一列的右边框 */
.table-cell:last-child {
  border-right: none;
}

/* 列宽分配（按内容重要性调整） */
.cell-1 {
  flex: 0 0 22%; /* 服务类型列：固定22%宽度 */
  min-width: 180px; /* 最小宽度，避免过窄 */
}
.cell-2 {
  flex: 1; /* 描述列：自适应宽度（占剩余空间） */
  min-width: 280px;
}
.cell-3 {
  flex: 0 0 32%; /* 适用场景列：固定32%宽度（预留对勾空间） */
  min-width: 240px;
  align-items: center; /* 对勾与文字垂直居中 */
  gap: 10px; /* 对勾与文字间距（核心：确保紧跟不重叠） */
}

/* 对勾图标：绿色圆形+白色对勾（与图片一致） */
.check-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%; /* 圆形 */
  background-color: #28a745; /* 绿色背景 */
  color: white; /* 白色对勾 */
  font-weight: bold;
  font-size: 12px; /* 对勾大小 */
  line-height: 1; /* 消除垂直偏移 */
  flex-shrink: 0; /* 对勾不缩放，始终在最前面 */
}

/* 最后一列文字容器：限制宽度，分行不超对勾位置 */
.scenarios-text {
  flex: 1;
  max-width: calc(100% - 30px); /* 总宽度 - 对勾宽度(20px) - 间距(10px) */
  line-height: 1.8;
  word-break: break-word; /* 长单词自动换行，避免超出 */
}

/* 平板端适配（768px ~ 992px） */
@media (min-width: 768px) and (max-width: 992px) {
  .table-cell {
    padding: 14px 30px; /* 平板左右30px间距 */
    font-size: 13px;
  }
  .cell-1 {
    flex: 0 0 20%;
    min-width: 160px;
  }
  .cell-3 {
    flex: 0 0 30%;
    min-width: 220px;
    gap: 8px;
  }
  .check-icon {
    width: 18px;
    height: 18px;
    font-size: 11px;
  }
  .scenarios-text {
    max-width: calc(100% - 26px); /* 26=18+8 */
  }
}

/* 移动端适配（≤ 768px）：转为卡片式布局 */
@media (max-width: 768px) {
  /* 表头隐藏 */
  .table-header {
    display: none;
  }

  /* 数据行转为块级元素（卡片） */
  .table-row {
    display: block;
    margin-bottom: 18px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }

  /* 偶数行卡片背景色 */
  .table-row.even-row {
    background-color: #f8f9fd;
  }

  /* 单元格：移动端左右10px间距（核心） */
  .table-cell {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    padding: 14px 10px; /* 移动端左右10px间距 */
    border: none;
    border-bottom: 1px solid #f0f0f0;
    font-size: 13px;
    text-align: left;
  }

  /* 最后一个单元格去掉下边框 */
  .table-cell:last-child {
    border-bottom: none;
  }

  /* 列宽限制取消（移动端自适应） */
  .cell-1, .cell-2, .cell-3 {
    flex: none;
    min-width: auto;
    width: 100%;
    align-items: flex-start; /* 移动端对勾与文字顶部对齐 */
    gap: 8px;
  }

  /* 通过 data-label 显示列名（模拟表头） */
  .table-cell::before {
    content: attr(data-label);
    flex: 0 0 auto;
    font-weight: 600;
    color: #2a43c9; /* 列名颜色与表头一致 */
    text-align: left;
    margin-bottom: 8px;
    font-size: 14px;
  }

  /* 移动端最后一列：对勾紧跟文字前 */
  .scenarios-text {
    max-width: calc(100% - 26px); /* 26=18+8 */
  }
  .check-icon {
    width: 18px;
    height: 18px;
    font-size: 11px;
  }
}
</style>